// extracted by mini-css-extract-plugin
export default {"defaultTrigger":"LanguageSelector_defaultTrigger__I76Gw","newLangButton":"LanguageSelector_newLangButton__LRnx+"};